








































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {PModuleWithMeasurements} from './../../system/modules/interfaces';
import {DateTimeInterval} from '@/utils/dateTimeItervalUtils';
import {getNow, getNowWithInterval} from '@/utils/dateTimeUtils';
import Loading from '@c/controls/Loading.vue';
import MachineWorkingDiagram from '@c/services/monitorErrors/MachineWorkingDiagram.vue';
import DiagramLegendTable from '@c/diagrams/DiagramLegendTable.vue';
import Chips from '@/components/controls/Chips.vue';
import {getArrayData} from '@u/machineWorkingUtils';
import {
  statusDiagramColorScheme as colorScheme,
  machineWorkingStatusTitles as titleScheme,
} from '@c/system/configurate';
import {getDurationStr} from '@u/dateTimeUtils';
import {httpClient} from '@/api/baseApi';

@Component({
  components: {
    Loading,
    MachineWorkingDiagram,
    DiagramLegendTable,
    Chips,
  },
})
export default class HeaterMonitorModuleWorkloadCard extends Vue {
  @Prop()
  pmodule!: PModuleWithMeasurements | null;

  diagramKey = 0;

  loading = false;
  error = false;

  states: any[] = [];

  legendData: any[] = [];

  viewRoundingAccuracy = 2;

  labelsLegendTable = [
    {name: 'Статус', field: 'name'},
    {name: 'Время', field: 'value'},
    {name: '%', field: 'percent'},
  ];

  period: {name: string; duration: any; intervalCustom?: DateTimeInterval} = {
    name: 'час',
    duration: {hours: 1},
  };

  periods: {name: string; duration: any; intervalCustom?: DateTimeInterval}[] = [
    {
      name: '5 минут',
      duration: {minutes: 5},
    },
    {name: 'час', duration: {hours: 1}},
    {
      name: '12 часов',
      duration: {hours: 12},
    },
    {name: 'сутки', duration: {days: 1}},
    {name: 'интервал', duration: null, intervalCustom: {startDateTime: 0, endDateTime: 0}},
  ];

  colorsBgInterval = [colorScheme.off, colorScheme.idle, colorScheme.work, colorScheme.incorrect];

  legendInfo = [
    {color: colorScheme.off, name: titleScheme.off},
    {color: colorScheme.idle, name: titleScheme.idle},
    {color: colorScheme.work, name: titleScheme.work},
    {color: colorScheme.incorrect, name: titleScheme.incorrect},
  ];

  endDateTime: any = null;

  startDateTime: any = null;

  @Watch('period')
  async onChangePeriod() {
    if (this.period.name) {
      this.getTime();
      this.getData();
    }
  }

  async created() {
    if (this.period.name) {
      this.getTime();
      this.getData();
    }
  }

  getTime() {
    this.endDateTime =
      this.period?.intervalCustom && this.period.intervalCustom.endDateTime
        ? this.period.intervalCustom.endDateTime
        : getNow();
    this.startDateTime =
      this.period?.intervalCustom && this.period.intervalCustom.startDateTime
        ? this.period.intervalCustom.startDateTime
        : getNowWithInterval(this.period.duration, 'minus');
  }

  async getData() {
    this.loading = true;
    this.error = false;
    const id = this.pmodule?.id;
    if (!id) return;

    try {
      const {data} = await httpClient.get(`heater-monitor-modules/${id}/workload`, {
        params: {
          start_date: this.startDateTime,
          end_date: this.endDateTime,
        },
      });
      const intervalsModes = data.map((elem: any) => ({
        start: elem.start,
        end: elem.end,
        mode: elem.unstatus,
      }));

      this.states = getArrayData(
        intervalsModes,
        this.colorsBgInterval,
        10,
        (elem: any) => elem.mode,
      );

      this.legendData = this.getLegendData(intervalsModes, this.startDateTime, this.endDateTime);

      (this.$refs.diagram as any).onChartMounted();
      this.diagramKey++;
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  getLegendData(intervalsModes: any[], startDate: number, endDate: number) {
    const aggregateTime = intervalsModes.reduce((res: any[], x: any) => {
      res[x.mode] = res[x.mode] + (x.end - x.start) || x.end - x.start;
      return res;
    }, {});

    return this.legendInfo.map((elem: any, index: number) => ({
      ...elem,
      value: getDurationStr(aggregateTime[index]),
      percent: this.countPercent(aggregateTime[index], startDate, endDate),
    }));
  }

  countPercent(aggregateTimeinMillsSec: number, startDate: number, endDate: number) {
    if (!aggregateTimeinMillsSec || endDate === startDate)
      return (0).toFixed(this.viewRoundingAccuracy);
    return ((aggregateTimeinMillsSec / (endDate - startDate)) * 100).toFixed(
      this.viewRoundingAccuracy,
    );
  }
}
